import React, {Fragment as F, Component} from 'react'
import Location from '../../../../model/Location'
import FieldGroup from 'lib/struct/form/fields/FieldGroup'
import Field from 'lib/struct/form/fields/Field'
import Select from 'lib/struct/form/Select'
import InputText from 'lib/struct/form/InputText'
import Radio from 'lib/struct/form/Radio'

import styles from './RegionsGroups.less'
import SettingsPageComponent from "../../SettingsPageComponent"
import Iconui from 'lib/struct/iconui/Iconui';

const {
    addRegionLink: addRegionLinkClass,
    buttonField: buttonFieldClass,
    resultButton: resultButton,
    countryField: countryFieldClass,
    'radio-block': radioBlock,
    'regions-list-title': regionsListTitle,
    'regions-list': regionsList,
    'regions-list__item': regionsListItem,
    'regions-list__item-name': regionsListItemName,
    'regions-list__btn': regionsListBtn,
    'region-search-block': regionSearchBlock,
    'region-search-block__field-wrapper': regionSearchBlockFieldWrapper,
    'region-search-block__field': regionSearchBlockField,
    'region-search-block__btn': regionSearchBlockBtn,
} = styles

const RegionsList = ({regions, handleDeleteRegion}) => {
    return (
        <ul className={regionsList}>
            {regions.map(
                (region, key) => region.params && (
                    <li key={key} className={region.params.class || ''}>
                        <div className={regionsListItem}>
                            <span
                                className={regionsListItemName}>{region.params.country_name}, {region.params.region_name ||
                            <span className="gray">Любой</span>}, {region.params.city_name ||
                            <span className="gray">Любой</span>}</span>
                            <span className={regionsListBtn}>
									<a
                                        data-action="delete"
                                        onClick={() => handleDeleteRegion(region.region.id)}
                                    >
										<Iconui name="delete"/>
									</a>
								</span>
                        </div>
                    </li>
                )
            )}
        </ul>
    )
}

export default class RegionsGroups extends Component {
    constructor(props) {
        super()
        this.location = new Location()

        this.state = {
            ya_regions: [],
            settings: props.settings ? props.settings : {},
            fields: {
                region: {
                    open: false,
                    value: ''
                },
                button: {
                    open: false
                }
            },
            is_loading_regions: false,
            ya_region: false
        }
    }

    // componentWillMount() {
    //     let settings =
    //         this.props.settings.regions
    //             ? this.props.settings
    //             : {
    //                 regions: []
    //             }
    //
    //     this.set(settings)
    // }

    componentDidMount() {
        // this.location.getCountries().then(countries => {
        //     this.setState({
        //         countries: countries
        //     })
        // })

        let settings =
            this.props.settings.regions
                ? this.props.settings
                : {
                    regions: []
                }

        this.set(settings)

        this.workupAll()
    }

    render() {
        const {
            settings,
            fields,
            is_loading_regions,
            ya_regions
        } = this.state

        const currentRegions = settings.regions
        const includedRegions = []
        const excludedRegions = []

        currentRegions.forEach((region) => {
            if (region.included === '1') {
                includedRegions.push(region)
            } else {
                excludedRegions.push(region)
            }
        })

        return (
            <FieldGroup>
                <F>
                    <div className={regionSearchBlock}>
                        <div className={regionSearchBlockFieldWrapper}>
                            <InputText
                                value={fields.region.value}
                                onChange={e => this.handleChangeRegion(e.target.value)}
                                autoComplete="off"
                                className={regionSearchBlockField}
                                placeholder={'Введите полное название местоположения'}
                            />
                            <a
                                className={regionSearchBlockBtn + " button green"}
                                onClick={this.handleSearchRegion}
                            >
                                Найти
                            </a>
                        </div>

                        {ya_regions.length > 0 && (
                            <ul className={regionsList}>
                                {ya_regions.map(
                                    (ya_region, key) => (
                                        <li key={key}>
                                            <div className={regionsListItem}>
                                                <Radio
                                                    name={'ya_region'}
                                                    value={key}
                                                    checked={ya_region.id === this.state.ya_region.id}
                                                    onChange={this.handleChangeYaRegion}
                                                >
														<span className={regionsListItemName}>
															{this.getRegionFullName(ya_region)}
														</span>
                                                </Radio>
                                            </div>
                                        </li>
                                    )
                                )
                                }
                            </ul>
                        )}
                        {fields.button.open && (ya_regions.length === 0) && (
                            <div>
                                <h5>Регионы не найдены. Введите полное название региона или переформулируйте
                                    запрос.</h5>
                            </div>
                        )}
                        {ya_regions.length > 0 && (
                            <div className={buttonFieldClass}>
                                <a
                                    className={resultButton + " button green"}
                                    onClick={() => this.handleAddRegion('1')}
                                >
                                    Добавить
                                </a>
                                <a
                                    className={resultButton + " button red"}
                                    onClick={() => this.handleAddRegion('0')}
                                >
                                    Исключить
                                </a>
                            </div>
                        )}
                        {is_loading_regions && (
                            <Field>
                                <Iconui name="loading"/>
                            </Field>
                        )}
                    </div>

                    {includedRegions.length && !is_loading_regions ? (
                        <F>
                            <div className={regionsListTitle}>Доставка осуществляется по регионам:</div>
                            <RegionsList regions={includedRegions} handleDeleteRegion={this.handleDeleteRegion}/>
                        </F>
                    ) : (
                        ''
                    )}
                    {excludedRegions.length && !is_loading_regions ? (
                        <F>
                            <div className={regionsListTitle}>Кроме регионов:</div>
                            <RegionsList regions={excludedRegions} handleDeleteRegion={this.handleDeleteRegion}/>
                        </F>
                    ) : (
                        ''
                    )}
                </F>
            </FieldGroup>
        )
    }

    handleChange(name, value) {
        this.set({
            ...this.get(),
            [name]: value
        })
    }

    handleChangeYaRegion = (e) => {
        this.setState({
            ya_region: this.state.ya_regions[e.target.value]
        })
    }

    handleChangeRegion(region) {
        this.setState({
            fields: {
                ...this.state.fields,
                region: {
                    open: true,
                    value: region || ''
                },
            }
        })
    }

    handleSearchRegion = () => {
        if (this.props.campaign.auth_method == "api_key" && !this.props.campaign.api_key) {
            alert('Введите ApiKey в настройках авторизации')
            return false
        }

        if (this.props.campaign.auth_method == "oauth" && !this.props.campaign.ya_api_token) {
            alert('Введите API токен в настройках авторизации')
            return false
        }

        if (this.state.fields.region.value.length < 3) {
            return false
        }

        $.post(
            '?plugin=pokupki&module=api&action=geo',
            {'query': this.state.fields.region.value,
             'auth': {
                'auth_method': this.props.campaign.auth_method,
                'api_key': this.props.campaign.api_key,
                'ya_api_token': this.props.campaign.ya_api_token
             }
            },
            response => {
                if (response.status === 'error') {
                    alert(response.errors[0].message)
                } else {
                    this.setState({
                        ya_regions: response.regions,
                        fields: {
                            ...this.state.fields,
                            button: {
                                open: true
                            }
                        }
                    })
                }
            },
            'json'
        )
    }

    handleAddRegion = (val) => {
        const $checkedRegion = $('input[name="ya_region"]:checked')
        if ($checkedRegion.val()) {
            this.push(this.state.ya_regions[$checkedRegion.val()], val)
            this.clearRegionState()
        }
    }

    clearRegionState = () => {
        this.handleChangeRegion('')
    }

    handleDeleteRegion = (key) => {
        this.set({
            ...this.state.settings,
            regions: this.state.settings.regions.filter((_, i) => _.region.id !== key)
        })
        this.props.region.settings.regions = this.props.region.settings.regions.filter((_, i) => _.region.id !== key)
    }

    get(id = null, clearly = false) {
        const {settings} = this.state

        if (id !== null) {
            return settings[id]
        } else {
            if (clearly) {
                let clear_settings = settings

                if (settings.regions && settings.regions.length) {
                    settings.regions.map((region, region_key) => {
                        if (region.params) {
                            delete clear_settings.regions[region_key].params
                        }
                    })
                }

                return clear_settings
            } else return settings
        }
    }

    set(value) {
        this.setState({
            settings: value
        })
    }

    push(new_region, included) {
        const {settings} = this.state

        let add = true

        settings.regions.map((region, key) => {
            if (region.id == new_region.id) {
                region.params.class = 'warning'

                this.set(settings)

                setTimeout(() => {
                    region.params.class = null

                    this.set(settings)
                }, 1000)

                add = false
            }
        })

        if (add) {
            settings.regions.push({
                region: new_region,
                included
            })

            this.set(settings)

            this.workupAll()
        }
    }

    workup(key, callback = false) {
        const {settings} = this.state

        if (!settings.regions[key].region.params) {
            let country_name,
                region_name = ''


            const region = this.getRegionByType(settings.regions[key].region, 'REPUBLIC_AREA')
            region_name = region.name


            const county = this.getRegionByType(settings.regions[key].region)
            country_name = county.name


            let params = {
                country_name: country_name || '',
                region_name: region_name || '',
                city_name: settings.regions[key].region.name || ''
            }

            settings.regions[key].params = params

            if (typeof callback === 'function') callback()


        }
    }

    workupAll() {
        const {settings} = this.state

        if (settings.regions && settings.regions.length > 0) {
            settings.regions.map((region, key) => {
                if (!region.params || region.params === null) {
                    this.setState({
                        is_loading_regions: true
                    })

                    let callback = false
                    if (key + 1 === settings.regions.length)
                        callback = () => {
                            this.setState({
                                is_loading_regions: false
                            })
                        }

                    this.workup(key, callback)
                }
            })
        }

        this.props.region.settings = settings
    }

    getRegionByType(ya_region, type = "REPUBLIC") {
        if (ya_region.parent) {
            if (ya_region.parent.type === type) {
                return ya_region.parent
            } else {
                return this.getRegionByType(ya_region.parent, type)
            }
        }

        return {"name": ""}
    }

    getRegionFullName(ya_region) {
        let name = ya_region.name
        let county = ''
        while (ya_region.parent) {
            county += ', ' + ya_region.parent.name
            ya_region = ya_region.parent
        }
        return (<span><b>{name}</b>{county}</span>)
    }
}
